var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavourites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1494 6.85655C24.563 6.26797 23.8667 5.80107 23.1003 5.48251C22.334 5.16396 21.5126 5 20.6831 5C19.8535 5 19.0321 5.16396 18.2658 5.48251C17.4994 5.80107 16.8032 6.26797 16.2167 6.85655L14.9997 8.07749L13.7826 6.85655C12.5981 5.66822 10.9915 5.00062 9.31633 5.00062C7.64114 5.00062 6.03455 5.66822 4.85001 6.85655C3.66547 8.04489 3 9.65662 3 11.3372C3 13.0177 3.66547 14.6295 4.85001 15.8178L6.06705 17.0387L13.5523 24.5479C14.3509 25.3491 15.6485 25.3491 16.4471 24.5479L23.9323 17.0387L25.1494 15.8178C25.7361 15.2295 26.2015 14.531 26.519 13.7622C26.8366 12.9934 27 12.1694 27 11.3372C27 10.505 26.8366 9.68096 26.519 8.91216C26.2015 8.14336 25.7361 7.44486 25.1494 6.85655Z",
    fill: "#4269EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.3f9c7101c3a4abb331b4cbe04810a41f.svg";
export { ForwardRef as ReactComponent };